/**
 * Helper to store and restore last user/selected education center
 */

import { UserType } from './types';

/**
 * Gets loggedIn user id to use it as a localstorage key
 * @returns { UserType | undefined }
 */
const getAuthUserProfile = (): UserType | undefined => {
    const authUser = localStorage.getItem('auth_user');
    return authUser ? JSON.parse(authUser).profile : undefined;
};

/**
 * Stores selected education center for the loggedIn user
 * @param { number } educationCenterId
 */
export const storeSelectedEduCenter = (educationCenterId: number): void => {
    const userId = getAuthUserProfile()?.id;
    userId && localStorage.setItem(`${userId}`, `${educationCenterId}`);
};

export const getStoredEduCenter = (userId: number): number | undefined => {
    const storedLocalStorageItem = localStorage.getItem(`${userId}`);
    return storedLocalStorageItem ? +JSON.parse(storedLocalStorageItem) : undefined;
};

/**
 * Restores previously selected education center for the logged in user
 * @returns { number | undefined }
 */
export const restoreSelectedEduCenter = (): number | undefined => {
    const user = getAuthUserProfile();
    if (!user?.id) {
        return undefined;
    }

    const storedEduCenter = getStoredEduCenter(user.id);

    if (!storedEduCenter) {
        return undefined;
    }
    //check is storedEduCenter still exists in user details, otherwise - use first eduCenter from auth
    // TODO: potentially user.employees should be filtered by activeness before 'find' check
    const restoredEduCenter = user.employees.find((e) => e.educationCenterId === storedEduCenter)
        ? storedEduCenter
        : user.employees[0].educationCenterId;

    return restoredEduCenter;
};
